"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var ErrorBang = function ErrorBang(props) {
  return _react["default"].createElement("svg", {
    viewBox: "0 0 21 20",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    "aria-labelledby": "error-title",
    role: "img"
  }, _react["default"].createElement("title", {
    id: "error-title"
  }, "Error Icon"), _react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("polygon", {
    fill: "#C10018",
    fillRule: "nonzero",
    points: "2 18.7922078 18.3609023 18.7922078 10.1804511 3"
  }), _react["default"].createElement("polygon", {
    fill: "#FFFFFF",
    points: "10.9241285 16.2987013 9.43677375 16.2987013 9.43677375 14.6363636 10.9241285 14.6363636"
  }), _react["default"].createElement("polygon", {
    fill: "#FFFFFF",
    points: "10.9241285 12.974026 9.43677375 12.974026 9.43677375 9.64935065 10.9241285 9.64935065"
  }), _react["default"].createElement("path", {
    d: "M2,18.7922078 L18.3609023,18.7922078 L10.1804511,3 L2,18.7922078 Z M20.0051093,19.7922078 L0.355792995,19.7922078 L10.1804511,0.825889151 L20.0051093,19.7922078 Z",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })));
};

var _default = ErrorBang;
exports["default"] = _default;